import { storeToRefs } from "pinia";
import { useDateStore } from "../stores/datestore";
import { reactive, ref, watch } from "vue";
import { addDuration, cloneDate } from "../libs/date";

export function currentRangeStore() {
  const dateStore = useDateStore();
  let { selectedDate, duration, firstDay } = storeToRefs(dateStore);
  const currentRange = reactive({});
  watch(
    [selectedDate, duration, firstDay],
    () => {
      let _currentRange = {
        start: cloneDate(selectedDate.value),
        end: addDuration(cloneDate(selectedDate.value), {
          seconds: duration.value * 86400,
        }),
      };
      Object.assign(currentRange, _currentRange);
    },
    { immediate: true }
  );
  return currentRange;
}
